"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidEmailAddress = isValidEmailAddress;
exports.getParentBlogUrlPath = getParentBlogUrlPath;
exports.replaceAllProductsCategoryName = replaceAllProductsCategoryName;
exports.getAppBaseUrl = getAppBaseUrl;
exports.getRedirectToPurchases = getRedirectToPurchases;
exports.getRedirectToDetails = getRedirectToDetails;
exports.isCustomer = isCustomer;
exports.isTrialPortal = isTrialPortal;
exports.redirectToPublicFacingDirectory = redirectToPublicFacingDirectory;
exports.resetFilters = resetFilters;
exports.resetNotApplicableFilters = resetNotApplicableFilters;
exports.isCustomModule = isCustomModule;
exports.isEmailTemplate = isEmailTemplate;
exports.isSystemPage = isSystemPage;
exports.getPathToDirectoryFilteredBySubType = getPathToDirectoryFilteredBySubType;
exports.getArrOfTextValPairsForSelect = getArrOfTextValPairsForSelect;
exports.getAlphaSortedArrOfTextValPairsForSelect = getAlphaSortedArrOfTextValPairsForSelect;
exports.hasCertificationBadge = hasCertificationBadge;
exports.getMultiselectCheckboxFilterOptions = getMultiselectCheckboxFilterOptions;
exports.isTemplatePack = isTemplatePack;
exports.getQueryParamsForSingleselectFilters = getQueryParamsForSingleselectFilters;
exports.addQueryParamsForMultiselectFilters = addQueryParamsForMultiselectFilters;
exports.addQueryParamForPage = addQueryParamForPage;
exports.getQueryParams = getQueryParams;
exports.getUrlWithNonInitialFiltersAndPageShown = getUrlWithNonInitialFiltersAndPageShown;
exports.getQueryParamsWithParsedInt = getQueryParamsWithParsedInt;
exports.isOnlyOneMultiSelectFilterOptionSelected = isOnlyOneMultiSelectFilterOptionSelected;
exports.parseQueryParamsForMultiselectFilters = parseQueryParamsForMultiselectFilters;
exports.mergeGoodFiltersAndPage = mergeGoodFiltersAndPage;
exports.getEnglishTextFieldFromGoodTextObj = getEnglishTextFieldFromGoodTextObj;
exports.getEnglishTextFieldFromTextsMap = getEnglishTextFieldFromTextsMap;
exports.areAllSidebarFiltersAtInitialValue = areAllSidebarFiltersAtInitialValue;
exports.getSubTypesFromPackCounts = getSubTypesFromPackCounts;
exports.getSubTypesBelongingToGroup = getSubTypesBelongingToGroup;
exports.getClearedSidebarFilters = getClearedSidebarFilters;
exports.getPollIntervalInSeconds = getPollIntervalInSeconds;
exports.getPollIntervalInMilliseconds = getPollIntervalInMilliseconds;
exports.getSecondsElapsedBeforeNextPolling = getSecondsElapsedBeforeNextPolling;
exports.hasFifteenMinutesElapsed = hasFifteenMinutesElapsed;
exports.getButtonState = getButtonState;
exports.getBaseUrlForCustomers = getBaseUrlForCustomers;
exports.isBelowMinimumRequiredReviews = isBelowMinimumRequiredReviews;
exports.getUnselectedOptions = getUnselectedOptions;
exports.getMultiselectDropdownOptions = getMultiselectDropdownOptions;
exports.getMultiselectDropdownClass = getMultiselectDropdownClass;
exports.getMultiselectFilterObjAfterRemove = getMultiselectFilterObjAfterRemove;
exports.getProviderSignupErrorMessagePath = getProviderSignupErrorMessagePath;
exports.getPurchaseButtonClassNames = getPurchaseButtonClassNames;
exports.getUrlWithProviderFilter = getUrlWithProviderFilter;

var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _underscore = require("underscore");

var _I18n = _interopRequireDefault(require("I18n"));

var _classnames = _interopRequireDefault(require("classnames"));

var _EmailAddress = _interopRequireDefault(require("PatternValidationJS/patterns/EmailAddress"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _ModuleCompatibilityTagTypes = _interopRequireDefault(require("marketplace-lib/constants/ModuleCompatibilityTagTypes"));

var _CustomModulePurposeOptions = _interopRequireDefault(require("../constants/CustomModulePurposeOptions"));

var _EmailCodingTypeOptions = _interopRequireDefault(require("../constants/EmailCodingTypeOptions"));

var _FeatureOptions = _interopRequireDefault(require("../constants/FeatureOptions"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _GoodsPriceOptions = _interopRequireDefault(require("../constants/GoodsPriceOptions"));

var _GoodSubTypeGroups = _interopRequireDefault(require("../constants/GoodSubTypeGroups"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _InitialFilterParams = _interopRequireDefault(require("../constants/InitialFilterParams"));

var _NumericFilterParams = _interopRequireDefault(require("../constants/NumericFilterParams"));

var _SystemPageSubTypes = _interopRequireDefault(require("../constants/SystemPageSubTypes"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _ButtonStates = _interopRequireDefault(require("../constants/ButtonStates"));

var _ReviewListParams = require("../constants/ReviewListParams");

var _env = require("../utils/env");

var _sidebarUtils = require("./sidebarUtils");

function isValidEmailAddress(email) {
  return _EmailAddress.default.test(email);
}

function getParentBlogUrlPath(asset) {
  return "/blog?selected=" + asset.getIn(['model', 'parentBlog', 'id']);
}

function replaceAllProductsCategoryName(categoryName) {
  if (categoryName === 'all products') {
    return _I18n.default.text('goodsZeroState.categoryNameForAllProducts');
  }

  return categoryName;
}

function getAppBaseUrl() {
  return "https://app.hubspot" + ((0, _env.isProd)() ? '' : 'qa') + ".com";
}

function getShortLinkToMarketplace() {
  return getAppBaseUrl() + "/l/marketplace";
}

function getRedirectToPurchases() {
  return getShortLinkToMarketplace() + "/manage-purchases";
}

function getRedirectToDetails(providerUrlToken, goodNameUrlToken) {
  return getShortLinkToMarketplace() + "/products/" + providerUrlToken + "/" + goodNameUrlToken;
}

function isCustomer(portal) {
  return (0, _underscore.isObject)(portal) && !!portal.portal_id;
}

function isTrialPortal(portal) {
  return (0, _underscore.isObject)(portal) && !!portal.trial;
}

function redirectToPublicFacingDirectory() {
  window.location = 'http://marketplace.hubspot.com/products';
}

function resetFilters(filterTypes, newGoodFiltersAndPage) {
  filterTypes.forEach(function (filterType) {
    newGoodFiltersAndPage[filterType] = _InitialFilterParams.default.get(filterType);
  });
  return newGoodFiltersAndPage;
}

function resetNotApplicableFilters(currentGoodFiltersAndPage, newGoodFiltersAndPage) {
  if (newGoodFiltersAndPage.subType) {
    if (currentGoodFiltersAndPage.get('subType') === _GoodSubTypes.default.EMAIL_TEMPLATES) {
      newGoodFiltersAndPage = resetFilters([_GoodFiltersAndPage.default.CODING_TYPE], newGoodFiltersAndPage);
    } else if (currentGoodFiltersAndPage.get('subType') === _GoodSubTypes.default.PACKS) {
      newGoodFiltersAndPage = resetFilters([_GoodFiltersAndPage.default.CHILD_TYPES], newGoodFiltersAndPage);
    } else if (currentGoodFiltersAndPage.get('subType') === _GoodSubTypes.default.CUSTOM_MODULE) {
      newGoodFiltersAndPage = resetFilters([_GoodFiltersAndPage.default.MODULE_PURPOSE], newGoodFiltersAndPage);
      newGoodFiltersAndPage = resetFilters([_GoodFiltersAndPage.default.MODULE_COMPATIBILITY], newGoodFiltersAndPage);
    }

    if (newGoodFiltersAndPage.subType === _GoodSubTypes.default.PACKS || newGoodFiltersAndPage.subType === _GoodSubTypes.default.CUSTOM_MODULE) {
      return resetFilters([_GoodFiltersAndPage.default.FEATURES, _GoodFiltersAndPage.default.PAGE_LAYOUT, _GoodFiltersAndPage.default.TEMPLATE_PURPOSE], newGoodFiltersAndPage);
    }
  }

  return newGoodFiltersAndPage;
}

function isCustomModule(goodDetails) {
  return goodDetails.get('subType') === _GoodSubTypes.default.CUSTOM_MODULE;
}

function isEmailTemplate(goodDetails) {
  return goodDetails.get('subType') === _GoodSubTypes.default.EMAIL_TEMPLATES;
}

function isSystemPage(subType) {
  return !!_SystemPageSubTypes.default[subType];
}

function getPathToDirectoryFilteredBySubType(goodSubType) {
  return "/products?subType=" + goodSubType;
}

function getArrOfTextValPairsForSelect(optionsArr, textLookupFunc) {
  return optionsArr.map(function (option) {
    return {
      text: textLookupFunc(option),
      value: option
    };
  });
}

function getAlphaSortedArrOfTextValPairsForSelect(optionsArr, textLookupFunc) {
  var firstItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var arrOfTextValPairs = getArrOfTextValPairsForSelect(optionsArr, textLookupFunc);
  var sortedArrOfTextValPairs = arrOfTextValPairs.sort(function (opt1, opt2) {
    return opt1.text.localeCompare(opt2.text);
  });

  if (firstItem) {
    sortedArrOfTextValPairs.unshift({
      text: textLookupFunc(firstItem),
      value: firstItem
    });
  }

  return sortedArrOfTextValPairs;
}

function hasCertificationBadge(providerCertsJsArr, certType) {
  return (0, _underscore.contains)(providerCertsJsArr, certType);
}

function getMultiselectCheckboxFilterOptions(filterType) {
  if (filterType === _GoodFiltersAndPage.default.PRICE) {
    return [_GoodsPriceOptions.default.FREE, _GoodsPriceOptions.default.PAID];
  } else if (filterType === _GoodFiltersAndPage.default.CODING_TYPE) {
    return [_EmailCodingTypeOptions.default.DRAG_AND_DROP, _EmailCodingTypeOptions.default.CODED_FILE];
  } else if (filterType === _GoodFiltersAndPage.default.CHILD_TYPES) {
    return [_GoodSubTypes.default.EMAIL_TEMPLATES, _GoodSubTypes.default.LANDING_PAGES, _GoodSubTypes.default.SITE_PAGES, _GoodSubTypes.default.BLOG_TEMPLATES, _GoodSubTypeGroups.default.SYSTEM_PAGE_TEMPLATES].filter(Boolean);
  } else if (filterType === _GoodFiltersAndPage.default.MODULE_COMPATIBILITY) {
    return [_ModuleCompatibilityTagTypes.default.COMPATIBLE_BLOG, _ModuleCompatibilityTagTypes.default.COMPATIBLE_EMAIL, _ModuleCompatibilityTagTypes.default.COMPATIBLE_PAGE];
  }

  return [];
}

function isTemplatePack(goodOrGoodDetails) {
  return goodOrGoodDetails.get('subType') === _GoodSubTypes.default.PACKS;
}

function isNonInitialValue(updatedGoodFilters, filterType) {
  return updatedGoodFilters.get(filterType) !== _InitialFilterParams.default.get(filterType);
}

function getQueryParamsForSingleselectFilters(singleSelectFilterTypes, updatedGoodFilters) {
  return singleSelectFilterTypes.filter(function (filterType) {
    return isNonInitialValue(updatedGoodFilters, filterType);
  }).map(function (filterType) {
    return (0, _defineProperty2.default)({}, filterType, updatedGoodFilters.get(filterType));
  });
}

function addQueryParamsForMultiselectFilters(queryParams, multiSelectFilterTypes, updatedGoodFilters) {
  multiSelectFilterTypes.forEach(function (filterType) {
    if (isNonInitialValue(updatedGoodFilters, filterType)) {
      queryParams.push((0, _defineProperty2.default)({}, filterType, updatedGoodFilters.get(filterType).toJS()));
    }
  });
  return queryParams;
}

function addQueryParamForPage(queryParams, updatedGoodFilters, addOneToAdjustForZeroIndexing) {
  if (isNonInitialValue(updatedGoodFilters, _GoodFiltersAndPage.default.PAGE)) {
    queryParams.push((0, _defineProperty2.default)({}, _GoodFiltersAndPage.default.PAGE, addOneToAdjustForZeroIndexing ? updatedGoodFilters.get(_GoodFiltersAndPage.default.PAGE) + 1 : updatedGoodFilters.get(_GoodFiltersAndPage.default.PAGE)));
  }

  return queryParams;
}

function getQueryParams(updatedGoodFilters) {
  var singleSelectFilterTypes = [_GoodFiltersAndPage.default.SEARCH_TERM, _GoodFiltersAndPage.default.PROVIDER, _GoodFiltersAndPage.default.SUB_TYPE, _GoodFiltersAndPage.default.SORT_BY, _GoodFiltersAndPage.default.INDUSTRY, _GoodFiltersAndPage.default.PAGE_LAYOUT, _GoodFiltersAndPage.default.TEMPLATE_PURPOSE, _GoodFiltersAndPage.default.LIMIT];
  var multiSelectFilterTypes = [_GoodFiltersAndPage.default.PRICE, _GoodFiltersAndPage.default.CODING_TYPE, _GoodFiltersAndPage.default.FEATURES, _GoodFiltersAndPage.default.CHILD_TYPES, _GoodFiltersAndPage.default.MODULE_COMPATIBILITY, _GoodFiltersAndPage.default.MODULE_PURPOSE];
  var queryParams = getQueryParamsForSingleselectFilters(singleSelectFilterTypes, updatedGoodFilters);
  queryParams = addQueryParamsForMultiselectFilters(queryParams, multiSelectFilterTypes, updatedGoodFilters);
  queryParams = addQueryParamForPage(queryParams, updatedGoodFilters, true);
  return queryParams;
}

function getUrlWithNonInitialFiltersAndPageShown(updatedGoodFilters) {
  return {
    pathname: '/products',
    query: Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(getQueryParams(updatedGoodFilters))))
  };
}

function parseNumericParam(queryParams, paramType) {
  if (!queryParams[paramType] || !_InitialFilterParams.default.has(paramType)) {
    return queryParams;
  }

  var parsedParamValue = parseInt(queryParams[paramType], 10);
  var parsedIntOrInitialValue = isNaN(parsedParamValue) ? _InitialFilterParams.default.get(paramType) : parsedParamValue;
  return (0, _extends4.default)({}, queryParams, (0, _defineProperty2.default)({}, paramType, parsedIntOrInitialValue));
}

function parseNumericParams(queryParams, paramTypes) {
  return paramTypes.reduce(parseNumericParam, queryParams);
}

function adjustPageToZeroIndex(queryParams) {
  var pageQueryParam = queryParams[_GoodFiltersAndPage.default.PAGE];

  if (pageQueryParam > 0) {
    return (0, _extends4.default)({}, queryParams, (0, _defineProperty2.default)({}, _GoodFiltersAndPage.default.PAGE, pageQueryParam - 1));
  }

  return queryParams;
}

function getQueryParamsWithParsedInt(queryParams) {
  return adjustPageToZeroIndex(parseNumericParams(queryParams, _NumericFilterParams.default));
}

function isOnlyOneMultiSelectFilterOptionSelected(filterOptionParams) {
  return (0, _underscore.isString)(filterOptionParams);
}

function parseQueryParamsForMultiselectFilters(queryParams) {
  var multiSelectFilterTypes = [_GoodFiltersAndPage.default.PRICE, _GoodFiltersAndPage.default.CODING_TYPE, _GoodFiltersAndPage.default.FEATURES, _GoodFiltersAndPage.default.CHILD_TYPES, _GoodFiltersAndPage.default.MODULE_COMPATIBILITY, _GoodFiltersAndPage.default.MODULE_PURPOSE];
  multiSelectFilterTypes.forEach(function (filterType) {
    if (isOnlyOneMultiSelectFilterOptionSelected(queryParams[filterType])) {
      queryParams[filterType] = [queryParams[filterType]];
    }
  });
  return queryParams;
}

function mergeGoodFiltersAndPage(existingGoodFiltersAndPage, newGoodFiltersAndPage) {
  return existingGoodFiltersAndPage.merge(newGoodFiltersAndPage);
}

function getEnglishTextFieldFromArrOfMultiLangObjects(arr) {
  if (arr) {
    var enLangObj = (0, _underscore.findWhere)(arr, {
      language: 'EN'
    });

    if (enLangObj) {
      return enLangObj.text;
    }

    return '';
  }

  return '';
}

function getEnglishTextFieldFromGoodTextObj(field, goodTextObj) {
  return getEnglishTextFieldFromArrOfMultiLangObjects(goodTextObj[field]);
}

function getEnglishTextFieldFromTextsMap(field, textsMap) {
  return getEnglishTextFieldFromArrOfMultiLangObjects(textsMap.get(field).toJS());
}

function areAllSidebarFiltersAtInitialValue(goodFilters) {
  return (0, _sidebarUtils.isMainCategory)(goodFilters.get(_GoodFiltersAndPage.default.SUB_TYPE)) && goodFilters.get(_GoodFiltersAndPage.default.PRICE).equals(_InitialFilterParams.default.get(_GoodFiltersAndPage.default.PRICE)) && goodFilters.get(_GoodFiltersAndPage.default.INDUSTRY) === _InitialFilterParams.default.get(_GoodFiltersAndPage.default.INDUSTRY) && goodFilters.get(_GoodFiltersAndPage.default.CHILD_TYPES).equals(_InitialFilterParams.default.get(_GoodFiltersAndPage.default.CHILD_TYPES)) && goodFilters.get(_GoodFiltersAndPage.default.FEATURES).equals(_InitialFilterParams.default.get(_GoodFiltersAndPage.default.FEATURES)) && goodFilters.get(_GoodFiltersAndPage.default.PAGE_LAYOUT) === _InitialFilterParams.default.get(_GoodFiltersAndPage.default.PAGE_LAYOUT) && goodFilters.get(_GoodFiltersAndPage.default.TEMPLATE_PURPOSE) === _InitialFilterParams.default.get(_GoodFiltersAndPage.default.TEMPLATE_PURPOSE) && goodFilters.get(_GoodFiltersAndPage.default.CODING_TYPE).equals(_InitialFilterParams.default.get(_GoodFiltersAndPage.default.CODING_TYPE)) && goodFilters.get(_GoodFiltersAndPage.default.PROVIDER) === _InitialFilterParams.default.get(_GoodFiltersAndPage.default.PROVIDER) && goodFilters.get(_GoodFiltersAndPage.default.MODULE_PURPOSE).equals(_InitialFilterParams.default.get(_GoodFiltersAndPage.default.MODULE_PURPOSE)) && goodFilters.get(_GoodFiltersAndPage.default.MODULE_COMPATIBILITY).equals(_InitialFilterParams.default.get(_GoodFiltersAndPage.default.MODULE_COMPATIBILITY));
}

function getSubTypesFromPackCounts(packCounts) {
  return packCounts.map(function (packCount) {
    return packCount.get('subType');
  }).toArray();
}

function getSubTypesBelongingToGroup(subTypeGroup) {
  var systemPages = Object.keys(_SystemPageSubTypes.default);
  var pages = [_GoodSubTypes.default.LANDING_PAGES, _GoodSubTypes.default.SITE_PAGES].concat((0, _toConsumableArray2.default)(systemPages));

  switch (subTypeGroup) {
    case _GoodSubTypeGroups.default.SYSTEM_PAGE_TEMPLATES:
      return systemPages;
    // TODO deprecated

    case _GoodSubTypeGroups.default.PAGE_TEMPLATES:
      return pages;

    case _GoodSubTypeGroups.default.TEMPLATES:
      return [_GoodSubTypes.default.EMAIL_TEMPLATES, _GoodSubTypes.default.BLOG_TEMPLATES, _GoodSubTypes.default.LANDING_PAGES, _GoodSubTypes.default.SITE_PAGES].concat((0, _toConsumableArray2.default)(systemPages));

    default:
      return [];
  }
}

function getClearedSidebarFilters() {
  var _ref2;

  var mainCategory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _GoodSubTypes.default.ALL;
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, _GoodFiltersAndPage.default.SUB_TYPE, mainCategory), (0, _defineProperty2.default)(_ref2, _GoodFiltersAndPage.default.PRICE, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.PRICE)), (0, _defineProperty2.default)(_ref2, _GoodFiltersAndPage.default.CODING_TYPE, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.CODING_TYPE)), (0, _defineProperty2.default)(_ref2, _GoodFiltersAndPage.default.INDUSTRY, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.INDUSTRY)), (0, _defineProperty2.default)(_ref2, _GoodFiltersAndPage.default.CHILD_TYPES, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.CHILD_TYPES)), (0, _defineProperty2.default)(_ref2, _GoodFiltersAndPage.default.FEATURES, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.FEATURES)), (0, _defineProperty2.default)(_ref2, _GoodFiltersAndPage.default.PAGE_LAYOUT, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.PAGE_LAYOUT)), (0, _defineProperty2.default)(_ref2, _GoodFiltersAndPage.default.TEMPLATE_PURPOSE, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.TEMPLATE_PURPOSE)), (0, _defineProperty2.default)(_ref2, _GoodFiltersAndPage.default.MODULE_PURPOSE, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.MODULE_PURPOSE)), (0, _defineProperty2.default)(_ref2, _GoodFiltersAndPage.default.MODULE_COMPATIBILITY, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.MODULE_COMPATIBILITY)), (0, _defineProperty2.default)(_ref2, _GoodFiltersAndPage.default.PROVIDER, _InitialFilterParams.default.get(_GoodFiltersAndPage.default.PROVIDER)), _ref2;
}

function getPollIntervalInSeconds(elapsedSeconds) {
  if (elapsedSeconds < 2 * 60) {
    return 2;
  } else if (elapsedSeconds < 10 * 60) {
    return 10;
  }

  return 3 * 60;
}

function getPollIntervalInMilliseconds(elapsedSeconds) {
  return getPollIntervalInSeconds(elapsedSeconds) * 1000;
}

function getSecondsElapsedBeforeNextPolling(elapsedSeconds) {
  return elapsedSeconds + getPollIntervalInSeconds(elapsedSeconds);
}

function hasFifteenMinutesElapsed(elapsedSeconds) {
  return elapsedSeconds === 15 * 60;
}

function getButtonState(requestStatus) {
  switch (requestStatus) {
    case _RequestStatusTypes.default.UNINITIALIZED:
    case _RequestStatusTypes.default.FAILED:
      return _ButtonStates.default.INITIAL;

    case _RequestStatusTypes.default.PENDING:
      return _ButtonStates.default.SAVING;

    default:
      return _ButtonStates.default.INITIAL;
  }
}

function getBaseUrlForCustomers() {
  return "/marketplace/" + _hubspot.default.get();
}

function isBelowMinimumRequiredReviews(reviewCount) {
  return reviewCount < _ReviewListParams.MINIMUM_REVIEWS_REQUIRED_TO_DISPLAY;
}

function getUnselectedOptions(optionsObj, selectedFiltersList) {
  return Object.keys((0, _underscore.omit)(optionsObj, selectedFiltersList.toJS()));
}

function getMultiselectDropdownOptions(filterType) {
  if (filterType === _GoodFiltersAndPage.default.FEATURES) {
    return (0, _underscore.omit)(_FeatureOptions.default, _FeatureOptions.default.NONE);
  } else if (filterType === _GoodFiltersAndPage.default.MODULE_PURPOSE) {
    return (0, _underscore.omit)(_CustomModulePurposeOptions.default, _CustomModulePurposeOptions.default.NONE);
  }

  return {};
}

function getMultiselectDropdownClass(filterType) {
  if (filterType === _GoodFiltersAndPage.default.FEATURES) {
    return 'integrate-feature-dropdown';
  } else if (filterType === _GoodFiltersAndPage.default.MODULE_PURPOSE) {
    return 'integrate-module-purpose-dropdown';
  }

  return '';
}

function getMultiselectFilterObjAfterRemove(filterType, selectedFilters, filterToRemove) {
  return (0, _defineProperty2.default)({}, filterType, selectedFilters.filter(function (filter) {
    return filter !== filterToRemove;
  }));
}

function getProviderSignupErrorMessagePath(fieldsWithErrors) {
  var errorMessage = fieldsWithErrors.get('message');

  if (errorMessage.includes('domain')) {
    return 'providerSignup.errorModal.domainMessage';
  } else if (errorMessage.includes('email')) {
    return 'providerSignup.errorModal.emailMessage';
  } else if (errorMessage.includes('password')) {
    return 'providerSignup.errorModal.passwordMessage';
  }

  return 'providerSignup.errorModal.genericMessage';
}

function getPurchaseButtonClassNames(previewMode) {
  return (0, _classnames.default)('purchase-button', 'integrate-purchase-button', {
    'preview-mode': previewMode
  });
}

function getUrlWithProviderFilter(providerName) {
  return getUrlWithNonInitialFiltersAndPageShown(_InitialFilterParams.default.merge((0, _defineProperty2.default)({}, _GoodFiltersAndPage.default.PROVIDER, providerName)));
}